import EntryEditForm from "../Components/TransactionEditForm";

function Edit() {
  return (
    <div className="New Edit p-4">
      <h2>Edit</h2>
      <EntryEditForm />
    </div>
  );
}

export default Edit;
